
<br><br><br><br><br><br>
<br><br><br><br><br><br>
<h2>Send-email works!</h2>
<button (click)="sendEmail()">Send Email via Cloud Function</button>
